import { render, staticRenderFns } from "./ReportPostView.vue?vue&type=template&id=1e8da5b2&scoped=true&"
import script from "./ReportPostView.vue?vue&type=script&lang=js&"
export * from "./ReportPostView.vue?vue&type=script&lang=js&"
import style0 from "./ReportPostView.vue?vue&type=style&index=0&id=1e8da5b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8da5b2",
  null
  
)

export default component.exports